module.exports = __webpack_public_path__ + "img/twitter.7e145c9e.svg";